import React from 'react';
import { Input, ModalBody} from "reactstrap";
import { useEntity} from "react-admin-base";
import {CheckBox, ImagePicker, ModalEntityEditor, SingleFilePicker} from "react-admin-base-bootstrap";
import {Field} from "../../Components/Fields";
import {LanguageSelect} from "../../Components/Selects";

export default function TeamMemberEntity({url, onReload, id}) {
    const entity = useEntity('/team-member', id, { });
    const [data, setData] = entity;

    if (!data) {
        return null;
    }

    return <ModalEntityEditor size="lg" title="Team Member Management" url={url} onReload={onReload} entity={entity}>
        <ModalBody>
            <CheckBox
                type="checkbox"
                id="active"
                label="Active"
                className="mb-3"
                checked={data.enabled}
                onChange={a => setData({enabled: !data.enabled})}
            />
            <Field title="Language">
                <LanguageSelect
                    value={data?.language}
                    onChange={a => setData({language: a})}
                />
            </Field>
            <Field title="Photo" type="required">
                <ImagePicker
                    width={305}
                    height={305}
                    type="png"
                    value={data.photo}
                    onChange={a => setData({photo: a})}
                />
            </Field>
            <Field title="Name" type="required">
                <Input type="text"
                    value={data.name}
                    onChange={a => setData({name: a.currentTarget.value})}
                />
            </Field>
            <Field title="Title" type="required">
                <Input type="textarea"
                    rows={2}
                    value={data.title}
                    onChange={a => setData({title: a.currentTarget.value})}
                />
            </Field>
            <Field title="Bio" type="required">
                <Input type="textarea"
                    rows={4}
                    value={data.bio}
                    onChange={a => setData({bio: a.currentTarget.value})}
                />
            </Field>
            <Field title="Order" type="required|numeric">
                <Input type="text"
                    value={data.order}
                    onChange={a => setData({order: a.currentTarget.value})}
                />
            </Field>
            <Field title="Instagram URL" type="url">
                <Input type="text"
                    value={data.instagram_url}
                    onChange={a => setData({instagram_url: a.currentTarget.value})}
                />
            </Field>
            <Field title="LinkedIn URL" type="url">
                <Input type="text"
                    value={data.linkedin_url}
                    onChange={a => setData({linkedin_url: a.currentTarget.value})}
                />
            </Field>
            <Field title="Twitter URL" type="url">
                <Input type="text"
                    value={data.twitter_url}
                    onChange={a => setData({twitter_url: a.currentTarget.value})}
                />
            </Field>
        </ModalBody>
    </ModalEntityEditor>;
}